import {
  useMutation,
  UseMutationResult,
} from '@tanstack/react-query';
import {
  ExecuteSupportSqlRequest,
  GenerateSupportSqlRequest,
  SupportSqlExecutionResult,
  SupportSqlGenerationResult,
} from 'dtos';
import {
  postApiSupportSqlExecuteSql,
  postApiSupportSqlGenerateSql,
} from 'endpoints';

export function usePopulateSupportGenerateSql():
UseMutationResult<SupportSqlGenerationResult, Error, GenerateSupportSqlRequest> {
  return useMutation<SupportSqlGenerationResult, Error, GenerateSupportSqlRequest>({
    mutationFn: (data) => postApiSupportSqlGenerateSql(data),
  });
}

export function usePopulateSupportExecuteSql():
UseMutationResult<SupportSqlExecutionResult, Error, ExecuteSupportSqlRequest> {
  return useMutation<SupportSqlExecutionResult, Error, ExecuteSupportSqlRequest>({
    mutationFn: (data) => postApiSupportSqlExecuteSql(data),
  });
}
